import { BasicService } from "./core/basic.service";

export class HomeService extends BasicService {
  static async shopIndex() {
    const data = await this.http.post('/goods/shopIndex')
    return Promise.resolve(data)
  }
}